import React, { useEffect, useRef } from 'react'
import SearchBar from '../../../components/SearchBar/SearchBar'
import Button from '../../../components/Button/Button'
import './AllMentorsStyle.css'
import { useState } from 'react'
import MentorsCard from '../../../components/Mentorscard/MentorsCard'
import MentFilters from '../../../components/MentFilters/MentFilters'
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { clearMentors, clearState, getAllUsersByProgram, getInterestsAndTopics, menteeData } from '../../../reducer/menteeSlice'
import DatanotFound from '../../../components/DatanotFound/DatanotFound'
import PageLoader from '../../../components/loaders/PageLoader/PageLoader'
import ErrorToast from '../../../components/Toast/ErrorToast'
import SuccessToast from '../../../components/Toast/SuccessToast'
import Skeleton from 'react-loading-skeleton'


const AllMentors = () => {

  //filter popup
  const [filterpoup, setfilterpoup] = useState();

  //Total count
  const [totalCount, setTotalCount] = useState(0);

    //Search states
  const [search, setSearch] = useState("");
  const [experience, setExperience] = useState("");
  const [topic, setTopic] = useState("");
  const [interest, setInterest] = useState("");
  const [topicOptions, setTopicOptions] = useState([]);
  const [interestOptions, setInterestOptions] = useState([]);

  //Load more states
  const [index, setIndex] = useState(1);
  const [totalMentors, setTotalMentors] = useState([]);

  //Toast states
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isShowSuccess, setIsShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ref = useRef();

  const { isMentorsFetching, isSuccess, isError, errorMessage, allMentors, interestTopics } =
    useSelector(menteeData);

  //Search functions
  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearch(value);
  };

  const handleSearch = (e) => {
      setTotalMentors([]);
      setIndex(1);
      dispatch(getAllUsersByProgram({ search }));
      setTotalCount(0);
  };

  const handleSearchPress = (e) => {
    if (e.key === "Enter") {
      setTotalMentors([]);
      setIndex(1);
      dispatch(getAllUsersByProgram({ search }));
      setTotalCount(0);
    }
  };

  //filter functions
  const handleExperienceFilter = (filter) => {
    setExperience(filter);
  };

  const handleExpertiseFilter = (filter) => {
    setTopic(filter);
  };

  const handleInterestFilter = (filter) => {
    setInterest(filter);
  };

  const handleDiscardFilters= () => {
    setInterest("");
    setExperience("");
    setTopic("");
  }

  const handleFilterResult = () => {
      setTotalMentors([]);
      setIndex(1);
      dispatch(getAllUsersByProgram({ search, experience, topic, interest }));
      setfilterpoup(false);
  };

  //Load More functions
  const handleLoadMore = () => {
    setIndex((prev) => prev + 1);
    dispatch(
      getAllUsersByProgram({ search, user: "mentor", index: index + 1, topic, interest, experience })
    );
  };

  //initial useEffect
  useEffect(() => {
    dispatch(getInterestsAndTopics());
    dispatch(getAllUsersByProgram({}));

    return () => {
      dispatch(clearMentors());
    }
  }, []);

  useEffect(() => {
    if(interestTopics && Object.keys(interestTopics).length > 0) {
      setTopicOptions(interestTopics?.topics?.map(item => {
        return {
          label: item?.Topic,
          value: item?.id
        }
      }))
      setInterestOptions(interestTopics?.interests?.map(item => {
        return {
          label: item?.interest,
          value: item?.id
        }
      }))
    }
  },[interestTopics])

  useEffect(() => {
    if (index === 1 && allMentors?.users?.length > 0) setTotalMentors(allMentors?.users);
    if (index !== 1 && allMentors?.users?.length > 0) setTotalMentors((prev) => [...prev, ...allMentors?.users]);
    if(allMentors?.totalCount) setTotalCount(allMentors?.totalCount);
  }, [allMentors]);

  useEffect(() => {
    if(isError) {
      setIsShowError(true);
      setErrMessage(errorMessage);
      dispatch(clearState());
    }
  },[isError])

  // useEffect(() => {
  //   if(isSuccess) {
      
  //     dispatch(clearState());
  //   }
  // },[isSuccess])

  const targetRef = useRef(null);

    useEffect(() => {

        const element = document.querySelector(".mainWrapper");

        const handleScroll = () => {
          if (targetRef.current) {
            const { top } = targetRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
            if (top <= windowHeight) {
              handleLoadMore();
            }
          }
        };
    
        element.addEventListener('scroll', handleScroll);
    
        return () => {
          element.removeEventListener('scroll', handleScroll);
        };
      }, [handleLoadMore]);

  return (
        <>
        {/* {isMentorsFetching && <PageLoader />} */}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <SuccessToast
        show={isShowSuccess}
        setShow={() => setIsShowSuccess(false)}
        message={successMessage}
      />
        <div className='AllMentorsCardWrapper'>
            <MentFilters isActive={filterpoup} handleFilterResult={handleFilterResult} handleDiscardFilters={handleDiscardFilters}  setIsActive={setfilterpoup} interests={interestOptions} topics={topicOptions} selectedTopic={topic} selectedInterest={interest} selectedExperience={experience} handleExperienceChange={handleExperienceFilter} handleTopicChange={handleExpertiseFilter} handleInterestChange={handleInterestFilter} />
            <div className="headingwrap flex-between">
                <div>
                    <h2 className='heading-2 mb6'>{isMentorsFetching ? <Skeleton width={"100px"} /> : 'Mentors'}</h2>
                    <p className='text3' ref={ref}>{isMentorsFetching ? <Skeleton width={"160px"} /> : `${totalCount ?? 0} Mentors in all`}</p>
                </div>

            </div>

            <div className="FaqUserFiltter flex-between mt30">
                {isMentorsFetching ? <Skeleton width={"200px"} height={"30px"} /> : <SearchBar placeholder={'Search here...'} className={'searchbardesign'} value={search} onChange={handleSearchChange} onKeyDown={handleSearchPress} onClick={handleSearch} />}
                {isMentorsFetching ? <Skeleton width={"100px"} height={"30px"} /> : <div className="FilterButtonPast flex gap-10" >
                    <Button name={'Filters'} src={'/assets/img/Filter list.png'} className={'filterbtn'} onClick={() => setfilterpoup(true)} />
                </div>}
            </div>


            <div className="CardWrapAllMentors">
                {totalMentors?.length > 0 ? totalMentors?.map((item, index) => (
                    <MentorsCard key={index} profile={item?.profileImg ? item?.profileImg : "/assets/img/user2.jpeg"} name={item?.firstName ? `${item?.firstName} ${item?.lastName}` : "---"}
                    field={item?.profession?.designation ? item?.profession?.designation: "---"} company={item?.profession?.company ? item?.profession?.company : "---"} year={item?.profession?.yrsOfExp ? `${item?.profession?.yrsOfExp} yrs of Experience` : "---"}
                    rating={item?.ratings} skill1={item?.interests?.length > 0 ? item?.interests[0]?.interest : ""} skill2={item?.interests?.length > 1 ? item?.interests[1]?.interest : ""} skill3={item?.interests?.length > 2 ? `${item?.interests?.length - 2}+` : ""} onClick={() => navigate(`/mentee/mentor-profile/${item?.id}`)}
                    />
                    )) : !isMentorsFetching && <DatanotFound />}
                    {isMentorsFetching &&
                <>
                {[1,2,3,4,5,6,7,8,9,10].map(item => (
                  <div className='MentMainCardWrapper Meboxbgcard'>
                  <div className="MeCardcontentdata">
                      <Skeleton width={"100px"} height={"100px"} circle />
                      <div className="Mentnameh mt-10">
                          <h3 className='heading-2 mb4'>{<Skeleton width={"100px"} />}</h3>
                          <p className='text3'>{<Skeleton width={"80px"} />}</p>
                      </div>
                      <div className="MentExperdata">
                          {<Skeleton width={"150px"} />}
                          {<Skeleton width={"150px"} />}
                      </div>
                      {<Skeleton width={"170px"} />}
                      <div className="profileData Mentdivdataskill">
                          <div className="dataexpertise2">
                          {<Skeleton width={"100px"} />}
                          </div>
                      </div>
                  </div>
              </div> 
                ))}
            </>}
                {(totalMentors.length < allMentors?.totalCount && !isMentorsFetching) && <div className="lodeemorebutton mt10" ref={targetRef}>
                    <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                </div>}

            </div>
            {/* <Paginationarrow /> */}
        </div>
                </>
    )
}

export default AllMentors